import React, { FC, useState } from 'react';
import { Section } from '@design-system/section';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { NavigationOptions } from 'swiper/types';

import CarouselSlide from './CarouselSlide';
import CustomTab from './CustomTab';
import { customTabsMockedData } from './customTabsMockedData';
import { ICustomTabs } from './models';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

SwiperCore.use([Navigation, Pagination]);

const customFontForPages = 'adult';

const CustomTabs: FC<ICustomTabs> = ({ variant }) => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const { tabs } = customTabsMockedData[variant];
  const isAdult = !variant.toLowerCase().includes(customFontForPages);

  const handleSetActiveTab = (index: number) => {
    setActiveTab(index);
  };

  return (
    <Section
      className="custom-tabs"
      element="section"
      mode="default-alt-custom"
      id="numero-de-servicos-1"
    >
      <div className="custom-tabs__wrapper">
        {tabs.map(({ button, image }, index) => (
          <CustomTab
            key={button.label}
            button={button}
            image={image}
            handleSetActiveTab={() => handleSetActiveTab(index)}
          />
        ))}
      </div>
      <div className="custom-tabs__content">
        <div className="custom-tabs__carousel__nav">
          <button
            type="button"
            className="swiper-button-prev custom-prev-tabs"
            aria-label="Diapositiva anterior"
          />

          <button
            type="button"
            className="swiper-button-next custom-next-tabs"
            aria-label="Siguiente diapositiva"
          />
        </div>
        <Swiper
          key={activeTab}
          slidesPerView={1}
          spaceBetween={0}
          navigation={{
            prevEl: '.custom-prev-tabs',
            nextEl: '.custom-next-tabs',
          }}
          onBeforeInit={(swiper) => {
            const navigation = swiper.params.navigation as NavigationOptions;

            navigation.prevEl = '.custom-prev-tabs';
            navigation.nextEl = '.custom-next-tabs';
          }}
          pagination={false}
          className="custom-tabs__carousel-swiper"
        >
          {tabs[activeTab].tabContent.map((el) => (
            <SwiperSlide key={el.title}>
              <CarouselSlide {...el} customTitle={isAdult} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Section>
  );
};

export default CustomTabs;
